import { UITimerStore } from 'common/stores/UITimerStore';
import { ITimerStrategy } from '.';
import { DisplayConfigType } from '../../config';
import { TIMERS } from 'common/stores/constants/timers.constant';

export class AutoCloseTimer implements ITimerStrategy {
  constructor(private formatConfig: DisplayConfigType) {}

  isRunnable(): boolean {
    return (
      this.formatConfig?.closeBtn?.autoCloseAfter !== 0 &&
      typeof this.formatConfig?.closeBtn?.autoCloseAfter !== 'undefined' &&
      !window.isOgyPreview
    );
  }

  run(uiTimerStore: UITimerStore): void {
    uiTimerStore.addTimer(
      TIMERS.AUTO_CLOSE_TIMER,
      this.formatConfig?.closeBtn?.autoCloseAfter * 1000
    );

    uiTimerStore.get(TIMERS.AUTO_CLOSE_TIMER)!.resume();
  }
}
